<script setup lang="ts">
import { useSendForm } from '@/features/Manuals/TabsConfig/model/api.ts'
import { type PropType, ref } from 'vue'
import type { InventTab } from '@/entities/Manuals/Tabs'

const props = defineProps({
  item: {
    type: Object as PropType<InventTab>,
    required: true,
  },
  field: {
    type: String,
    default: 'is_show',
  },
  label: {
    type: String,
    default: '',
  },
})

const { sendForm, isPending } = useSendForm()
const value = ref(props.item[props.field])

/**
 * Функция отправки данных
 */
const changeHandler = () => {
  sendForm(
    {
      ...props.item,
      [props.field]: value.value,
    },
    true,
    false,
  )
}
</script>

<template>
  <VCheckbox v-model="value" :label :loading="isPending" density="compact" @change="changeHandler" />
</template>
